import { render, staticRenderFns } from "./RiskPermitWorkDocWrite.vue?vue&type=template&id=5158b620&scoped=true&"
import script from "./RiskPermitWorkDocWrite.vue?vue&type=script&lang=js&"
export * from "./RiskPermitWorkDocWrite.vue?vue&type=script&lang=js&"
import style0 from "./RiskPermitWorkDocWrite.vue?vue&type=style&index=0&id=5158b620&prod&lang=scss&scoped=true&"
import style1 from "./RiskPermitWorkDocWrite.vue?vue&type=style&index=1&id=5158b620&prod&lang=scss&scoped=true&"
import style2 from "./RiskPermitWorkDocWrite.vue?vue&type=style&index=2&id=5158b620&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5158b620",
  null
  
)

export default component.exports